// extracted by mini-css-extract-plugin
module.exports = {"phoneInputContainer":"PhoneFlagText_phoneInputContainer__3HQSd"};